export default __webpack_public_path__ + "static/media/PaymentSolution.22ed4644.png";